import { Badge, Tooltip, cn } from '@skupreme/shared/ui';

export type HeldBadgeProps = {
  /** V2 only (EN-4403): the order has a real exception an operator must clear. */
  held: boolean | undefined;
  /** The list row's chip size; the detail card uses the default badge. */
  compact?: boolean;
  className?: string;
};

/**
 * EN-4403: held is a flag, not a tab: the order keeps its state. Only a real
 * exception counts (an unmatched item, a risk hold, an address the check
 * refused); waiting for a provider to be chosen is not held.
 */
export function HeldBadge({ held, compact, className }: HeldBadgeProps) {
  if (!held) {
    return null;
  }

  return (
    <Tooltip
      placement="bottom start"
      content="This order has an exception to clear before it can ship."
    >
      <span className={cn('sk:inline-flex sk:cursor-default', className)}>
        <Badge
          tone="danger"
          className={cn(compact && 'sk:text-xs sk:font-normal')}
        >
          Held
        </Badge>
      </span>
    </Tooltip>
  );
}
